module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI5MTJlYzY2ZDc1NzJmZjgyMTc0OTMxOTM5NjQ3MGJkZS5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 490
// module chunks = 1